import { read, doMocked, isMocked } from "../api";
import { key } from "./action";

export const SERVICE_ENDPOINT = "samples";

export const readSamples = (body) => {
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT);
  return read(`${SERVICE_ENDPOINT}`, body);
};
